import { AuthentificationEndpoints } from "../../Routes/api/Endpoints";
import { logout, setAccessToken } from "../../redux/features/userSliceWithTokenValidation";
import { ApiMananger } from "../../redux/libs/apiManager";


export const authApi = ApiMananger.injectEndpoints({ 
  endpoints: (build) => ({
    loginUser: build.mutation({
      query: ({ email, password }) => ({
        url: AuthentificationEndpoints.postUserLogin,
        method: "POST",
        body: { email, password },
      }),
    }),

    // Récupérer les catégories avec services et sous-services et projets
    fetchCategoriesProjets: build.query({
      query: (endpoints) => ({
        url: endpoints,
        method: "GET",
      }),
      transformResponse: (response) => response.categories_projets,
      invalidatesTags: ["Categories"],
    }),
    fetchServicesProjets: build.query({
      query: (endpoints) => ({
        url: endpoints,
        method: "GET",
      }),
      transformResponse: (response) => response.services,
      invalidatesTags: ["Services"],
    }),

    logoutUser: build.mutation({
      query: () => ({
        url: AuthentificationEndpoints.logout,
        method: "POST",
      }),
      async onQueryStarted(_, { dispatch }) {
        dispatch(logout());
      },
    }),
    refreshToken: build.mutation({
      query: () => ({
        url: AuthentificationEndpoints.refreshToken,
        method: "POST",
      }),
      onSuccess: (response, { dispatch }) => {
        const { access } = response.data;
        dispatch(setAccessToken(access));
      },
    }),
    addProject: build.mutation({
      query: ({ endpoints, formData }) => ({
        url: endpoints,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Projects"],
    }),
    modifyProjectImage: build.mutation({
      query: ({ projectId, formData }) => ({
        url: `/modifier-image-projet/${projectId}`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Projects"],
    }),
    postData: build.mutation({
      query: ({ endpoint, elementID, formData }) => ({
        url: `${endpoint}${elementID}`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Projects"],
    }),
    deleteData: build.mutation({
      query: ({ endpoint, dataId }) => ({
        url: `${endpoint}${dataId}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Projects", "Notifications"],
    }),
    putTask: build.mutation({
      query: ({ endpoint, task }) => {
        return {
          url: `${endpoint}${task?.id}`,
          method: "PUT",
          body: task,
        };
      },
      invalidatesTags: ["Projects", "Notifications"],
    }),
    patchData: build.mutation({
      query: ({ endpoint, task }) => {
        return {
          url: `${endpoint}${task?.id}`,
          method: "PATCH",
          body: task,
        };
      },
      invalidatesTags: ["Notifications"],
    }),
    // fetchProjects: build.query({
    //   query: (endpoints) => ({
    //     url: endpoints,
    //     method: "GET",
    //   }),
    //   transformResponse: (response) => response.projects,
    //   invalidatesTags: ["Projects"],
    // }),
    fetchNotifications: build.query({
      query: (endpoints) => ({
        url: endpoints,
        method: "GET",
      }),
      transformResponse: (response) => response.notifications,
      // keepUnusedDataFor: 5,
      invalidatesTags: ["Projects", "Notifications"],
    }),
    getData: build.query({
      query: ({ endpoint, projectId }) => {
        if (projectId) {
          return `${endpoint}${projectId}`;
        }
        return endpoint;
      },
      invalidatesTags: ["Projects"],
    }),
    getDataById: build.query({
      query: ({ endpoint, id }) => {
        if (id) {
          return `${endpoint}${id}`;
        }
        return endpoint;
      },
      providesTags: ["Projects"],
    }),
    fetchCategories: build.query({
      query: (onSelectCategory) => {
        if (!onSelectCategory) {
          return { url: "", method: "GET" };
        }
        return {
          url: `/categories-templates`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useLoginUserMutation,
  useLogoutUserMutation,
  useRefreshTokenMutation,
  useAddProjectMutation,
  useModifyProjectImageMutation,
  // useFetchProjectsQuery,
  useGetDataQuery,
  usePostDataMutation,
  useDeleteDataMutation,
  usePutTaskMutation,
  useFetchCategoriesQuery,
  useFetchNotificationsQuery,
  useFetchCategoriesProjetsQuery,
  useFetchServicesProjetsQuery,
  usePatchDataMutation,
  useGetDataByIdQuery,
} = authApi;

// export default authApi